export default __webpack_public_path__ + "static/media/tab-slider-4.35d1c50b.png";